import { createStyles } from '@mui/styles';
import { APTheme } from "../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
    BecomePartnerCompleteContainer: {
        width: "auto",
        height: "100%",
        maxWidth: 576,
        margin: 'auto',
        padding: '3rem',
        [theme.breakpoints.down('lg')]: {
            width: '100%'
        },
    },
    BecomePartnerCompleteCopy: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '1em',
        textAlign: 'center'
    },
    title: {
        marginBottom: 10
    },
    subTitle: {
        marginBottom: 10,
        fontSize: 16,
        fontWeight: 500,
    },
    titleParagraph: {
        fontSize: 16,
        display: 'block',
        marginBottom: 40
    },
    mailIcon: {
        marginBottom: 40,
        height: '173px',
        width: '173px',
        margin: '0 auto',
    },
    link: {
        color: "#2d91e9",
        textDecoration: "none",
        fontFamily: "CircularStd",
        fontSize: 16,
    }
});
